module.exports = __webpack_public_path__ + "img/h5_game_detail_infinity8_express.42fe5a8a.jpg";